import React from 'react';

import { Text, useMantineTheme } from '@mantine/core';

interface CallSummaryProps {
  summary?: string;
}

export function CallSummary({ summary }: CallSummaryProps) {
  const theme = useMantineTheme();

  return (
    <Text size="md" color={theme.colors.gray[7]} lineClamp={4}>
      {summary}
    </Text>
  );
}
